import { Control } from "react-hook-form";
import { SplitDatePickerFormField } from "../../../formfields/DatePickerFormField/SplitDatePickerFormField";
import { PersonsVirtualizedSelectForm } from "../../../forms/EntityForms/formsVirtualized/PersonsVirtualizedSelectForm";

export const EnteredRecordEntityFilterForm = ({
  control,
  currentTab,
}: {
  control: Control<any, any, any>;
  currentTab: any;
}) => {
  return (
    <>
      {currentTab !== "mydata" && (
        <PersonsVirtualizedSelectForm
          id="enteredByIds"
          label="Entered by"
          control={control}
          isMulti
          filters={{ includeSystemUsers: true }}
        />
      )}

      <SplitDatePickerFormField
        control={control}
        idStart="enteredFrom"
        idEnd="enteredTo"
        label="Entered on (from - to)"
        horizontal={false}
        showTimeSelect
      />
    </>
  );
};
